import React, { createContext, useState, useContext, useEffect } from 'react';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
    const [token, setToken] = useState(null);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        // Au chargement, vérifier si un token existe dans le localStorage
        const storedToken = localStorage.getItem('authToken');
        if (storedToken) {
            setToken(storedToken);
        }
        setIsLoading(false);
    }, []);

    const login = (newToken) => {
        setToken(newToken);
        localStorage.setItem('authToken', newToken);
    };

    const logout = () => {
        setToken(null);
        localStorage.removeItem('authToken');
        window.location.href = '/login';
    };

    // Prépare l'en-tête d'autorisation pour les appels API
    const authHeader = () => {
        return token ? { 'Authorization': `Bearer ${token}` } : {};
    };

    const value = { token, isLoading, login, logout, authHeader };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    );
};

// Hook personnalisé pour utiliser facilement le contexte
export const useAuth = () => {
    return useContext(AuthContext);
};